/* eslint-disable import/prefer-default-export */
import styled from '@emotion/styled';
import UnstyledUploadIcon from '@material-ui/icons/Backup';
import COLORS from '$variables/colors';
import { spacing } from '$variables/theme';

export const UploadIcon = styled(UnstyledUploadIcon)`
  color: ${COLORS.green};
  margin-right: ${spacing.xSmall};
  width: 20px;
  height: 20px;
`;
